import { ordersListingApi } from '@apis/seller-center/orders.js';
import { Toast } from '@common-web/index.js';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorString } from '@utils/utils.js';

const initialState = {
  ordersData: [],
  statuses: [],
  dispositions: [],
  pagination: null,
  success: false,
  loading: false,
  aggregations: [],
  cancelledDispositions: [],
};

export const fetchOrdersListing = createAsyncThunk('orders/listing', async (params = '') => {
  try {
    const orders = await ordersListingApi(params);
    return orders;
  } catch (err) {
    Toast.error(getErrorString(err));
  }
  return {};
});

const OrdersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders: (state, action) => {
      if (action.payload.id) {
        const index = state.ordersData?.findIndex((orderItem) => orderItem?.id === action.payload.id);
        if (index !== -1) {
          state.ordersData[index] = { ...state.ordersData[index], ...action.payload };
        }
      }
    },
    appendOrders: (state, action) => {
      state.ordersData = [...state.ordersData, ...(action?.payload?.orders ?? [])];
      state.pagination = action?.payload?.pagination;
    },
    filterDispositions: (state, action) => {
      if (action.payload?.statusIndex !== -1) {
        state.dispositions = state.statuses?.[action.payload.statusIndex]?.dispositions ?? [];
      } else {
        const newDispositions = state.statuses?.flatMap((status) => status.dispositions) ?? [];
        state.dispositions = Array.from(new Map(newDispositions.map((d) => [d?.slug, d])).values());
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchOrdersListing.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrdersListing.fulfilled, (state, action) => {
        state.ordersData = action?.payload?.orders;
        state.pagination = action?.payload?.pagination;
        state.aggregations = action?.payload?.aggregations;
        state.loading = false;
        state.statuses = action?.payload?.statuses_and_dispositions ?? [];
        state.bulkActions = action?.payload?.possible_bulk_actions ?? [];
        const cancelledStatus = action.payload.statuses_and_dispositions?.find((item) => item?.slug === 'cancelled');
        state.cancelledDispositions = cancelledStatus?.dispositions;
      });
  },
});

export const { setOrders, filterDispositions, appendOrders } = OrdersSlice.actions;
export default OrdersSlice.reducer;
